export class PdfDocumentTemplate {

    id: number;
    identifier: string;
    preview: string;
    pdfExample: string;
    invoiceJasper: string;
    ticketJasper: string;
    debitNoteJasper: string;
    creditNoteJasper: string;
    perceptionJasper: string;
    retentionJasper: string;
    despatchAdviceJasper: string;
    summaryDocumentJasper: string;
    raVoidadDocumentJasper: string;
    rrVoidadDocumentJasper: string;

    public logEstatusRegistro: string;
    public logUsernameRegistro: string;
    public logFechaRegistro: string;
    public logUsernameModificacion: string;
    public logFechaModificacion: string;

    constructor(id: number = null,
                identifier: string = "",
                preview: string = "",
                pdfExample: string = "",
                invoiceJasper: string = "",
                ticketJasper: string = "",
                debitNoteJasper: string = "",
                creditNoteJasper: string = "",
                perceptionJasper: string = "",
                retentionJasper: string = "",
                despatchAdviceJasper: string = "",
                summaryDocumentJasper: string = "",
                raVoidadDocumentJasper: string = "",
                rrVoidadDocumentJasper: string = "",
                logEstatusRegistro: string = "",
                logUsernameRegistro: string = "",
                logFechaRegistro: string = "",
                logUsernameModificacion: string = "",
                logFechaModificacion: string = "") {
        this.id = id;
        this.identifier = identifier;
        this.preview = preview;
        this.pdfExample = pdfExample;
        this.invoiceJasper = invoiceJasper;
        this.ticketJasper = ticketJasper;
        this.debitNoteJasper = debitNoteJasper;
        this.creditNoteJasper = creditNoteJasper;
        this.perceptionJasper = perceptionJasper;
        this.retentionJasper = retentionJasper;
        this.despatchAdviceJasper = despatchAdviceJasper;
        this.summaryDocumentJasper = summaryDocumentJasper;
        this.raVoidadDocumentJasper = raVoidadDocumentJasper;
        this.rrVoidadDocumentJasper = rrVoidadDocumentJasper;


        // CAMPOS DE AUDITORIA
        this.logEstatusRegistro = logEstatusRegistro;
        this.logUsernameRegistro = logUsernameRegistro;
        this.logFechaRegistro = logFechaRegistro;
        this.logUsernameModificacion = logUsernameModificacion;
        this.logFechaModificacion = logFechaModificacion;

    }
}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/recursos/modelo/PdfDocumentTemplate.ts